import React from "react";

interface TickCircleProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  size?: number;
}

export const TickCircle: React.FC<TickCircleProps> = ({ fill = "#4F5B94", size = 22, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="12.0684" cy="12" r="11" fill="white" />
    <path
      d="M12.0684 1C6.00736 1 1.06836 5.939 1.06836 12C1.06836 18.061 6.00736 23 12.0684 23C18.1294 23 23.0684 18.061 23.0684 12C23.0684 5.939 18.1294 1 12.0684 1ZM17.3264 9.47L11.0894 15.707C10.9354 15.861 10.7264 15.949 10.5064 15.949C10.2864 15.949 10.0774 15.861 9.92336 15.707L6.81036 12.594C6.49136 12.275 6.49136 11.747 6.81036 11.428C7.12936 11.109 7.65736 11.109 7.97636 11.428L10.5064 13.958L16.1604 8.304C16.4794 7.985 17.0074 7.985 17.3264 8.304C17.6454 8.623 17.6454 9.14 17.3264 9.47Z"
      fill={fill}
    />
  </svg>
);
